import './PublicRoadmapPage.css';
import SEO from '../components/SEO';

const PublicRoadmapPage = () => {
  return (
    <div className="roadmap-page">
      <SEO
        title="Public Roadmap | Sprout Academy"
        description="See what's in progress, planned next, and coming later on Sprout Academy's public development roadmap."
        path="/roadmap"
      />
      <main className="roadmap-page__main">
        <header className="roadmap-page__header">
          <h1>Public Roadmap</h1>
          <p className="roadmap-page__intro">
            We're building Sprout Academy in the open. Here's what we're working on, what's next, and what we're dreaming about for the future.
          </p>
        </header>

        <div className="roadmap-phases">
          <section className="roadmap-phase roadmap-phase--current">
            <div className="roadmap-phase__badge">In Progress</div>
            <h2>Phase 1: Foundation</h2>
            <p className="roadmap-phase__timeline">Q2 2026</p>
            <ul className="roadmap-phase__items">
              <li>✓ Core game engine and mechanics</li>
              <li>✓ World design</li>
              <li>✓ Year 1-3 maths curriculum mapping</li>
              <li>→ Parent weekly updates</li>
              <li>→ Initial testing</li>
            </ul>
          </section>

          <section className="roadmap-phase roadmap-phase--current">
            <div className="roadmap-phase__badge">In Progress</div>
            <h2>Phase 2: Launch</h2>
            <p className="roadmap-phase__timeline">Q3 2026</p>
            <ul className="roadmap-phase__items">
              <li>→ Founding Families early access</li>
              <li>→ Complete maths quest content (Years 1-3)</li>
              <li>→ Progress tracking refinements</li>
              <li>→ iPad app optimization</li>
            </ul>
          </section>

          <section className="roadmap-phase roadmap-phase--planned">
            <div className="roadmap-phase__badge">Planned</div>
            <h2>Phase 3: Expansion</h2>
            <p className="roadmap-phase__timeline">Q4 2026</p>
            <ul className="roadmap-phase__items">
              <li>Reception and Year 5-6 maths content</li>
              <li>Mobile app optimization (iOS/Android)</li>
              <li>Helper's Hollow quests for learning to be a good citizen</li>
              <li>Achievement system v2</li>
            </ul>
          </section>

          <section className="roadmap-phase roadmap-phase--planned">
            <div className="roadmap-phase__badge">Planned</div>
            <h2>Phase 4: The Content Boom</h2>
            <p className="roadmap-phase__timeline">Q1 2027 - Q2 2027</p>
            <ul className="roadmap-phase__items">
              <li>Science curriculum world (Wizard's Tower)</li>
              <li>History and art world (Museum)</li>
              <li>Cross-curricular quests</li>
              <li>Deeper storylines and world-building</li>
            </ul>
          </section>

          <section className="roadmap-phase roadmap-phase--future">
            <div className="roadmap-phase__badge">Future</div>
            <h2>Phase 5: Community and Scale</h2>
            <p className="roadmap-phase__timeline">2027 onwards</p>
            <ul className="roadmap-phase__items">
              <li>School partnerships program</li>
              <li>Welsh language version</li>
              <li>Annual content expansions (English, Geography and more)</li>
            </ul>
          </section>
        </div>

        <section className="roadmap-note">
          <h3>Our commitment</h3>
          <p>
            This roadmap represents our best intentions, not promises. We're committed to building something genuinely useful for families, and that means being responsive to feedback and willing to adjust course when needed.
          </p>
          <p>
            Want to influence what we build next? Join the Founding Families list and we'll be in touch about feedback sessions.
          </p>
        </section>
      </main>
    </div>
  );
};

export default PublicRoadmapPage;
